import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { ReturnDiscountCodeEmailRenderer } from "./email";
import type { ReturnDiscountCodeBlockProps } from "./types";

export function ReturnDiscountCodeEditorRenderer(
  props: ReturnDiscountCodeBlockProps,
) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <ReturnDiscountCodeEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
